import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const TOKEN_KEY = "tilesmate_session_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // The preview/deploy ingress rewrites the standard Origin header to an internal
  // cluster host, which breaks WebAuthn RP-ID validation. Send the true browser
  // origin in a custom header that passes through untouched.
  cfg.headers["X-App-Origin"] = window.location.origin;
  return cfg;
});

export default client;
